import { saveRecord } from '@/entities/shared/record/save-record';
import type { Item } from '../schemas/item';
import { itemSchema } from '../schemas/item';

export async function saveItem(id: string, data: Partial<Item>): Promise<void> {
  await saveRecord('items', itemSchema, id, data);
}
